import { useEffect } from 'react';
import { useQuery, useQueryClient, UseQueryResult } from 'react-query';
import { ArticleListItems } from '../../models/ArticleListItems';
import { FetchArticlesParams } from '../../services/articles/articles.models';
import useArticleUpdate from './useArticleUpdate';
import { mapToArticleListItems } from './utils/article.mappers';
import { fetchArticles, fetchMyFeedArticles } from '../../services/articles/articles.service';
import { queryKeys } from '../queryKeyFactory';

export default (params: FetchArticlesParams): UseQueryResult<ArticleListItems, Error> => {
  const queryClient = useQueryClient();
  const { receive } = useArticleUpdate('fetchArticles');
  const { isMyFeed, enabled, retry } = params;

  useEffect(() => {
    receive((article) => {
      queryClient.getQueriesData<ArticleListItems>(queryKeys.fetchArticles.all).forEach(([queryKey, data]) => {
        if (data?.rows) {
          const articleIndex = data.rows.findIndex((item) => item.id === article.id);

          if (articleIndex >= 0) {
            const rows = [...data.rows];
            rows.splice(articleIndex, 1, {
              ...rows[articleIndex],
              canAccess: article.canAccess,
            });

            queryClient.setQueryData<ArticleListItems>(queryKey, {
              ...data,
              rows,
            });
          }
        }
      });
    });
  }, [queryClient, receive]);

  return useQuery<ArticleListItems, Error>(
    queryKeys.fetchArticles.feedByParams(params),
    async () => {
      const articleListDto = isMyFeed ? await fetchMyFeedArticles(params) : await fetchArticles(params);
      return mapToArticleListItems(articleListDto);
    },
    {
      enabled,
      retry,
    }
  );
};
